"use client";

import React from "react";
import { Button } from "../common/button";

export interface UniqueFeature {
  icon: string;
  title: string;
  subtitle: string;
}

export interface WhyChooseAlliProps {
  title?: string;
  subtitle?: string;
  description?: string;
  features?: UniqueFeature[];
  primaryCtaText?: string;
  secondaryCtaText?: string;
  onPrimaryCtaClick?: () => void;
  onSecondaryCtaClick?: () => void;
  showCtas?: boolean;
}

export function WhyChooseAlli({
  title = "Why Choose Alli?",
  subtitle = "Our Unique Approach",
  description = "Questioning how we can offer therapy that's both affordable and exceptional? Get acquainted with The Alli Way.",
  features = [
    {
      icon: "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/65154e69ae1ad53c6e8aacf9_join-our-team-card-circle-icon-startux-webflow-ecommerce-template.svg",
      title: "Therapist Tiers",
      subtitle: "A Spectrum of Expertise"
    },
    {
      icon: "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/65154e69ae1ad53c6e8aad11_medical-assistance-card-icon-startux-webflow-ecommerce-template.svg",
      title: "Your Rate, Our Secret",
      subtitle: "Quality isn't determined by your rate"
    },
    {
      icon: "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/65154e69ae1ad53c6e8aac7f_process-card-icon-startux-webflow-ecommerce-template.svg",
      title: "Become an Alli",
      subtitle: "Guiltless giving and receiving are the hallmarks of being an Alli"
    }
  ],
  primaryCtaText = "Get Matched",
  secondaryCtaText = "More About Alli",
  onPrimaryCtaClick,
  onSecondaryCtaClick,
  showCtas = true
}: WhyChooseAlliProps) {
  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-2">
            {title}
          </h2>
          <p className="text-3xl font-light text-gray-900 mb-6">
            {subtitle}
          </p>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {description}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="bg-gray-50 rounded-3xl p-10 text-center transition-all duration-300 hover:bg-gray-100">
                <div className="mb-6">
                  <img 
                    src={feature.icon} 
                    alt={feature.title}
                    className="w-20 h-20 mx-auto"
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-lg">
                  {feature.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
        
        {showCtas && (
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              className="bg-primary-600 hover:bg-primary-700 text-white px-10 py-4 text-lg rounded-full"
              onClick={onPrimaryCtaClick}
            >
              {primaryCtaText}
            </Button>
            <Button 
              size="lg" 
              variant="outline"
              className="px-10 py-4 text-lg rounded-full border-2"
              onClick={onSecondaryCtaClick}
            >
              {secondaryCtaText}
            </Button>
          </div>
        )}
      </div>
    </section>
  );
}